import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { StockCountSandbox } from 'app/core/sandboxes/stock-count.sandbox';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { logger } from 'app/core/util/logger';
import { Observable } from 'rxjs';
import { StockCountsEffects } from './stock-count.effects';
import * as fromRoot from 'app/core/store/index';
import { debounceTime, filter, map } from 'rxjs/operators';

/**
 * Guard to async load a flow before following a route
 */
@Injectable({ providedIn: 'root' })
export class GetStockCountGuard implements CanActivate, DependencyTreeCanActivate {
  private sandbox: StockCountSandbox;
  private stockCountEffects: StockCountsEffects;
  private store: Store<fromRoot.RootState>

  constructor(@Inject(forwardRef(() => Store)) store, @Inject(forwardRef(() => StockCountSandbox)) sandbox, @Inject(forwardRef(() => StockCountsEffects)) stockCountEffects) {
    this.sandbox = sandbox;
    this.stockCountEffects = stockCountEffects;
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    logger.debug('In GetStockCountGuard');
    this.sandbox.getStockCountDetail(parseInt(route.paramMap.get('stockCountNumber'), 10));

    return this.store.select(state => state.stockCount.detail)
      .pipe(
        debounceTime(10), // make sure that load has started
        filter(detailState => detailState.loadSuccess || detailState.loadFailed),
        map(detailState => detailState.loadSuccess)
      );
  }

  getDependencies(): any {
    return [CustomerInfoLoadIfNormalUserGuard, AuthorizationGuard];
  }

  getDependencyRouteData(): any {
    return {};
  }
}
